import { render } from "./LwPageHeader.vue?vue&type=template&id=5f6bc730&scoped=true"
import script from "./LwPageHeader.vue?vue&type=script&lang=js"
export * from "./LwPageHeader.vue?vue&type=script&lang=js"

import "./LwPageHeader.vue?vue&type=style&index=0&id=5f6bc730&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f6bc730"]])

export default __exports__